import { format } from 'date-fns'

export function formatDate(created_at) {
  return format(new Date(created_at), 'MMMM d yyyy')
}
